import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  label: {
    color: theme.palette.primaryGrey,
    ...theme.typography.h6,
    marginBottom: "8px"
  }
}));
